<template>
  <div class="cont-footer">
    <div class="inner-box" :style="show?'padding-top:40px;':'padding-top:20px;'">
      <div class="lists" v-if="show">
        <div class="item item5">
          <h4>主营业务</h4>
          <ul>
            <li v-for="(val,index) in businessList" :key="index">
              <router-link :to="'/detail/business/'+ val.id +'?footerType=3'">{{val.title}}</router-link>
            </li>
          </ul>
        </div>
        <div class="item item2">
          <h4>解决方案</h4>
          <ul>
            <li v-for="(val,index) in solutionList" :key="index">
              <router-link :to="'/detail/solution/'+ val.id +'?footerType=2'">{{val.title}}</router-link>
            </li>
          </ul>
        </div>
        <div class="item item1">
          <h4>项目案例</h4>
          <ul>
            <li v-for="(val,index) in casesList" :key="index" @click="goto(val,index)">
              <router-link :to="'/detail/cases/'+ index +'?footerType=1'">{{val.title}}</router-link>
            </li>
            <!-- <li style="cursor:pointer" v-for="(val,index) in casesList" :key="index" @click="goto(val,index)">
              <a>{{val.title}}</a>
            </li>-->
          </ul>
        </div>
        <div class="item item3">
          <h4>联系我们</h4>
          <ul>
            <li>电话：{{company.phone}}</li>
            <li>邮编：{{company.code}}</li>
            <li>地址：{{company.Adress}}</li>
            <!-- <li>客服热线：{{company.service}}</li> -->
          </ul>
        </div>
        <div class="item item4">
          <p class="attention">关注我们</p>
          <img src="../assets/images/public/wechat.png" alt />
        </div>
      </div>
      <!-- <s class="line"> -->

      <span class="line1">
        <span>友情链接：</span>
        <!-- <a href="http://www.upzy.net/" target="_blank">友朋致远</a> -->
        <a class="jlt" href="http://www.cqjlt.net/" target="_blank">家乐淘</a>
        <!-- <a href="http://old.sunutech.net/" target="_blank">原尚优科技</a> -->
      </span>
      <span class="line2">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">渝ICP备19006387号</a>
        Copyright 2015 © 重庆尚优科技有限公司版权所有
      </span>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import local from "../utils/local";
import { listNextWithFilter, view } from "../api/index";
export default {
  name: "contfooter",
  props: ["show"],
  data() {
    return {
      solutionList: [], //解决方案
      casesList: [], //项目案例
      catlist: [
        require("../assets/video/city.mp4"),
        require("../assets/video/yl.mp4"),
        require("../assets/video/coummit.mp4")
      ],
      company: {}, //联系我们
      businessList: [], //主营业务
    };
  },
  methods: {
    // setPath(val) {
    //   local.set("prePath", val);
    //   local.set("localPath", val);
    // },
    goto(val, index) {
      let explainInfo = {
        title: val.title,
        caseIndex: index
      };
      // this.setPath("cases");
      local.set("explainInfo", explainInfo);
      // this.$router.push("/detail/" + index + "?footerType=1");
    },
    // 解决方案
    async getSolution() {
      let send = {
        url: {
          page: 1,
          size: 5
        },
        data: {
          categoryIdList: [this.$map.solucategoryId]
        }
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        this.solutionList = res.data;
      } else {
        console.log(res.msg);
      }
    },
    // 项目案例
    async getCases() {
      let send = {
        url: {
          page: 1,
          size: 5
        },
        data: {
          appIdList: [this.$map.casescategoryId]
        }
      };
      let res = await listNextWithFilter(send);
     
      if (res.type == "success") {
        this.casesList = res.data;
      } else {
        console.log(res.msg);
      }
    },
    //主营业务
    async getBusiness() {
      let send = {
        url: {
          page: 1,
          size: 5
        },
        data: {
          categoryIdList: [this.$map.buscategoryId]
        }
      };
      let res = await listNextWithFilter(send);
      if (res.type == "success") {
        this.businessList = res.data;
      } else {
        console.log(res.msg);
      }
    },
    //联系我们
    async getData() {
      let send = {
        url: {
          id: this.$map.aboutsunuId
        }
      };
      let res = await view(send);
      if (res.type == "success") {
        this.company = res.data.data;
      } else {
        console.log(res.msg);
      }
    },

    href(i) {
      if (i == 0) {
        window.open("http://www.upzy.net/", "_blank");
      } else if (i == 1) {
        window.open("http://www.upzy.net/", "_blank");
      } else {
        window.open("http://www.upzy.net/", "_blank");
      }
    }
  },
  mounted() {
    this.getSolution();
    this.getCases();
    this.getData();
    this.getBusiness();
    // this.pathMap.clear()
  }
};
</script>

<style scoped lang="less">
.cont-footer {
  background-color: #0060a3;
  position: relative;
  height: 100%;
  padding-bottom: 1vw;
  .inner-box {
    width: 92%;
    margin: 0 auto;
    color: #ffffff;
    padding-bottom: 20px;
    .lists {
      display: flex;
      justify-content: space-around;

      // width:66%;
      .item {
        letter-spacing: 2px;
        h4 {
          font-size: 16px;
          margin-bottom: 12px;
        }
        li {
          font-size: 10px;
          color: #ffffff;
          a {
            text-decoration: none;
            color: #ffffff;
            // opacity: 0.6;
            &:hover {
              opacity: 1;
              color: #eadede;
            }
          }
        }
        .attention {
          font-size: 16px;
          margin-bottom: 10px;
        }
      }
      .item3 {
        li {
          font-size: 10px;
          // opacity: 0.6;
        }
      }
      .item4 {
        position: absolute;
        right: 116px;
      }
      img {
        align-self: flex-start;
        // width: 20%;
        max-width: 120px;
      }
    }
    .line {
      height: 100%;
      display: flex;
      margin-top: 1vw;
    }
  }
}
@media screen and (min-width: 1200px) {
  .line1 {
    margin-top: 1vw;
    font-size: 10px;
    text-align: center;
    color: #fff;
    display: flex;
    // span {
    //   opacity: 0.6;
    // }
    a {
      text-decoration: none;
      margin-right: 10px;
      // opacity: 0.6;
      color: #fff;
      &:hover {
        opacity: 1;
      }
    }
  }
  .line2 {
    // display: inline-block;
    margin-left: -1.5vw;
    margin-top: 1vw;
    font-size: 10px;
    text-align: center;
    color: #ffffff;
    // opacity: 0.6;
    a {
      text-decoration: none;
      color: #fff;
    }
  }
  .inner-box {
    font-size: 16px;
    .lists {
      width: 70%;
    }
    .item {
      line-height: 20px;
      h4 {
        font-size: 16px;
      }
      li {
        line-height: 24px;
      }
    }
  }
  .line1 {
    position: absolute;
  }
  .line2 {
    margin-left: 45vw !important;
    position: absolute;
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  //ipad pro
  .inner-box {
    font-size: 13px;
    .lists {
      width: 70%;
    }
    .item {
      line-height: 20px;
      h4 {
        font-size: 19px;
      }
    }
    .line1 {
      //  border: 1px solid red;
      position: absolute;
    }
    .line2 {
      margin-left: 36vw !important;
      position: absolute;
    }
  }
    .line1 {
    margin-top: 1vw;
    font-size: 10px;
    text-align: center;
    color: #fff;
    display: flex;
    // span {
    //   opacity: 0.6;
    // }
    a {
      text-decoration: none;
      margin-right: 10px;
      // opacity: 0.6;
      color: #fff;
      &:hover {
        opacity: 1;
      }
    }
  }
  .line2 {
    // display: inline-block;
    margin-left: -1.5vw;
    margin-top: 1vw;
    font-size: 10px;
    text-align: center;
    color: #ffffff;
    // opacity: 0.6;
    a {
      text-decoration: none;
      color: #fff;
    }
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  //ipad
  .inner-box {
    font-size: 12px;
    .item {
      line-height: 20px;
      h4 {
        font-size: 18px;
      }
    }
  }

    .line1 {
    margin-top: 1vw;
    font-size: 10px;
    text-align: center;
    color: #fff;
    display: flex;
    // span {
    //   opacity: 0.6;
    // }
    a {
      text-decoration: none;
      margin-right: 10px;
      // opacity: 0.6;
      color: #fff;
      &:hover {
        opacity: 1;
      }
    }
  }
  .line2 {
    // display: inline-block;
    margin-left: -1.5vw;
    margin-top: 1vw;
    font-size: 10px;
    text-align: center;
    color: #ffffff;
    // opacity: 0.6;
    a {
      text-decoration: none;
      color: #fff;
    }
  }
}
@media screen and (max-width: 414px) {
  //phone
  .inner-box {
    width: 100% !important;
    font-size: 12px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    .item {
      line-height: 20px;
      h4 {
        font-size: 18px;
      }
    }
    .jlt {
      display: none;
    }
  }
  .line1 {
    margin-top: 1vw;
    font-size: 10px;
    text-align: center;
    color: #fff;
    display: flex;
    // span {
    //   opacity: 0.6;
    // }
    a {
      text-decoration: none;
      margin-right: 10px;
      // opacity: 0.6;
      color: #fff;
      &:hover {
        opacity: 1;
      }
    }
  }
  .line2 {
    // display: inline-block;
    margin-left: -1.5vw;
    margin-top: 1vw;
    font-size: 10px;
    text-align: center;
    color: #ffffff;
    // opacity: 0.6;
    a {
      text-decoration: none;
      color: #fff;
    }
  }
}
</style>
